/**
 * Compares original Excel integration data with saved data.
 * Returns true if there is a meaningful change (i.e. EDIT_FINANCIALS should fire).
 * Used to avoid firing EDIT when user clicks Save without making changes.
 */
function normalizeKpiDataForComparison(kpiData: unknown): string {
  if (kpiData == null) return '';
  const data = (kpiData as { data?: { value?: Array<{ id: number; value: number }> }; externalObjectExtra?: unknown })?.data;
  const value = data?.value;
  const extra = (kpiData as { externalObjectExtra?: unknown }).externalObjectExtra;
  // Sort by id for stable comparison
  const sortedValue = value
    ? [...value].sort((a, b) => a.id - b.id).map((v) => ({ id: v.id, value: v.value }))
    : [];
  return JSON.stringify({ value: sortedValue, externalObjectExtra: extra });
}

export function hasExcelIntegrationDataChanged(
  original: unknown,
  saved: unknown,
): boolean {
  if (original == null && saved == null) return false;
  if (original == null || saved == null) return true;
  return normalizeKpiDataForComparison(original) !== normalizeKpiDataForComparison(saved);
}
